import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/users/new` — l'invito non è più una pagina (01-11-2026).
 *
 * È il pannello «Invita un esterno» di «Utenti e ruoli» (`InviteExternalForm`): quattro campi si
 * compilano in un pannello, guardando l'elenco delle persone dietro, non in una pagina che lo
 * nasconde. L'indirizzo resta come rinvio e apre il pannello (`?invite=1`).
 */
export const Route = createFileRoute('/_app/users/new')({
  beforeLoad: () => { throw redirect({ to: '/organization/permissions', search: { invite: true }, replace: true }); },
});
